"use client";

import Link from "next/link";
import Image from "next/image";
import { useAuth } from "@/app/lib/auth";

export function LoginButton() {
  const { login } = useAuth();

  const handleLogin = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    login();
  };

  return (
    <button
      onClick={handleLogin}
      className="rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/90"
    >
      Login
    </button>
  );
}

export function LogoutButton() {
  const { logout } = useAuth();

  return (
    <button
      onClick={logout}
      className="px-4 py-2 rounded-md bg-destructive text-destructive-foreground hover:bg-destructive/90 transition-colors"
    >
      Log Out
    </button>
  );
}

export function ProfileButton() {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <Link
      href="/profile"
      className="flex items-center gap-2 px-4 py-2 rounded-md hover:bg-muted transition-colors"
    >
      {user.picture && (
        <div className="relative w-6 h-6 rounded-full overflow-hidden">
          <Image
            src={user.picture}
            alt={user.name || "Profile"}
            fill
            sizes="24px"
            className="object-cover"
            priority
          />
        </div>
      )}
      <span>{user.name || "Profile"}</span>
    </Link>
  );
}
